module.exports = __webpack_public_path__ + "static/media/5f5e43885a069.0d83c09b.jpg";